var pattern = /[-/\\^$*+?.()|[\]{}]/g;

export default function escapeRegExp ( str ) {
	return str.replace( pattern, '\\$&' );
}

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/utils/escapeRegExp.js.map
